import React, { useState, useEffect } from "react";
import { znajdzNajblizszaStawke } from '../../../../functions/stawki.js'
import { znajdzAktualny } from "../../../../functions/stawki.js";
import Loader from "../../../Loader.js";
import WspolnotaRozliczenieButtons from "../WspolnotaRozliczenieButtons.js";
import WspolnotaRozliczenieSeryjneTable from "./WspolnotaRozliczenieSeryjneTable.js";
import MieszkaniecWydruk from "../../../Mieszkaniec/Wydruk/MieszkaniecWydruk.js";
import WspolnotaRozliczenieSeryjneMasowa from "./WspolnotaRozliczenieSeryjneMasowa.js";
 
const WspolnotaRozliczenieSeryjne = props => {

  const { idw, wspolnota, mieszkancy, lokale, ulice, grupy, udzialyKontaAkt, stawki, stawkiJednorazowe, stawkiJednorazoweInd, czynszeMsc, 
    czynszeWspolnota, przelewyWspolnota, miesiac, setMiesiac, listaMsc, ind } = props;

  const [showPrint, setShowPrint] = useState(false)
  const [stawkiAkt, setStawkiAkt] = useState(undefined);
  const [loaderOn, setLoaderOn] = useState(false);

  const [rozliczeniaMieszkancow, setRozliczeniaMieszkancow] = useState(false);

  const [udzialyKonta_a, setUdzialyKonta_a] = useState([]);
  const [grupy_a, setGrupy_a] = useState([]);
  const [stawkiOst, setStawkiOst] = useState([]);
  const [mieszkaniec, setMieszkaniec] = useState(undefined);
  const [grupa_numer, setGrupa_numer] = useState(undefined);
  const [tablicaCzynszeAkt, setTablicaCzynszeAkt] = useState([]);

  const [tablicaObiektow, setTablicaObiektow] = useState([]);

  const zestaw = (id_user, grupa_numer) => {

    setUdzialyKonta_a( udzialyKontaAkt?.find(u => u.id_wspolnoty == idw && u.id_user == id_user && u.grupa_numer == grupa_numer) );
    setGrupy_a( grupy?.filter( g => g?.id_user == id_user && g?.grupa_numer == grupa_numer) );
    setMieszkaniec( mieszkancy?.find( m => m?.id_user == id_user));
    setGrupa_numer(grupa_numer);

    const czynsz1 = czynszeWspolnota?.find( c => c?.id_user == id_user).grupy_udzial_msc;
    const czynsz2 = czynsz1?.find( c => c?.grupa_numer == grupa_numer).temp_msc;
    setTablicaCzynszeAkt(czynsz2?.find( c => c?.msc == miesiac));
    
    handleShowPrintMieszkaniec();
  }

  useEffect( () => {
    const temp = [];

    udzialyKontaAkt?.forEach( (udzial, i) => {

      const mieszkaniec = mieszkancy?.find( m => m?.id_user == udzial?.id_user);
      const czynsz = czynszeWspolnota?.find( c => c?.id_user == udzial?.id_user)?.grupy_udzial_msc?.find( c => c?.grupa_numer == udzial?.grupa_numer)?.temp_msc?.find( m => m?.msc == miesiac);
      
      const grupy_a = grupy?.filter( g => g?.id_user == udzial.id_user && g?.grupa_numer == udzial.grupa_numer);

      temp.push(
        {
          udzialyKonta_a: udzial,
          mieszkaniec,
          tablicaCzynszeAkt: czynsz,
          grupy_a, 
          grupa_numer: udzial.grupa_numer
        }
      )

    }); 

    setTablicaObiektow(temp);

  },[udzialyKontaAkt, mieszkancy, czynszeWspolnota, grupy])

  useEffect( () => setStawkiOst(znajdzAktualny(stawki, miesiac)), [miesiac, stawki]);
  useEffect( () => setStawkiAkt( znajdzNajblizszaStawke(miesiac, stawki) ), [miesiac, stawki]);
  useEffect( () => czynszeWspolnota && przelewyWspolnota && czynszeMsc && ind ? setLoaderOn(false) : setLoaderOn(true), [czynszeWspolnota, przelewyWspolnota, czynszeMsc, ind]);

  const handleShowPrint = () => setShowPrint( prevState => !prevState);
  const handleShowPrintMieszkaniec = () => setRozliczeniaMieszkancow( prevState => !prevState);
  
  return (
    <div className="dane">
      <div className="left">
        <WspolnotaRozliczenieButtons
          miesiac={miesiac}
          setMiesiac={setMiesiac}
          listaMsc={listaMsc}
          setShowPrint={setShowPrint}
        />
        <WspolnotaRozliczenieSeryjneTable
          stawki={stawkiAkt}
          stawkiJednorazowe={stawkiJednorazowe}
          czynszeMsc={czynszeMsc}
          ind={ind}
          idw={idw}
          wspolnota={wspolnota}
          lokale={lokale}
          ulice={ulice}
          grupy={grupy}
          udzialyKontaAkt={udzialyKontaAkt}
          przelewyWspolnota={przelewyWspolnota}
          czynszeWspolnota={czynszeWspolnota}
          mieszkancy={mieszkancy}
          zestaw={zestaw}
        />
      </div>
      <div className="right">
        <WspolnotaRozliczenieSeryjneMasowa 
          tablicaObiektow={tablicaObiektow}
          showPrint={0}
          stawkiOst={stawkiOst}
          stawkiJednorazowe={stawkiJednorazowe}
          stawkiJednorazoweInd={stawkiJednorazoweInd}
          lokale={lokale}
          ulice={ulice}
          miesiac={miesiac}
          wspolnota={wspolnota}
        />

      </div>
                      
      {/* {
        rozliczeniaMieszkancow && (
          <MieszkaniecWydruk 
            udzialyKonta_a={udzialyKonta_a}
            showPrint={handleShowPrintMieszkaniec}
            mieszkaniec={mieszkaniec}
            tablicaCzynszeAkt={tablicaCzynszeAkt}
            
            

            grupy_a={grupy_a}
            
            grupa_numer={grupa_numer}
          />
        )
      } */}

      <Loader stan={loaderOn} />
    </div>
  )
}

export default WspolnotaRozliczenieSeryjne;